import actions from "./actions";

export default {
  namespaced: true,
  state: {
    itParks: [],
    itPark: null,
    dataLoading: false
  },

  getters: {
    itParks: state => {
      return state.itParks;
    },

    itPark: state => {
      return state.itPark;
    },

    dataLoading: state => {
      return state.dataLoading;
    }
  },

  mutations: {
    setItParks(state, itParks) {
      state.itParks = itParks;
    },

    setItPark(state, itPark) {
      state.itPark = itPark;
    },

    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    }
  },

  actions
};